const resetModalState = (state) => {
    Vue.set(state, 'activeModal', '');
    Vue.set(state, 'passedProps', {});
    Vue.set(state, 'callback', () => true);
    Vue.set(state, 'callbackCancel', () => true);
}

const state = {
    activeModal: '',
    passedProps: {},
    callback: () => true,
    callbackCancel: () => true,
};

const mutations = {
    SET_ACTIVE_MODAL: (state, modalData) => {
        if (typeof modalData === 'object') {
            Vue.set(state, 'activeModal', modalData.modal);
            Vue.set(state, 'passedProps', modalData.passedProps);
            Vue.set(state, 'callback', modalData.callback);
            Vue.set(state, 'callbackCancel', modalData.callbackCancel);
        } else {
            Vue.set(state, 'activeModal', modalData);
        }
    },
    CLOSE_MODAL: (state) => {
        resetModalState(state);
    },
    CLOSE_MODAL_ACCEPT: (state, callbackProps) => {
        if (typeof state.callback === 'function') state.callback(callbackProps);

        resetModalState(state);
    },
    UPDATE_MODAL_PROPS: (state, props) => {
        if (props.key) {
            Vue.set(state.passedProps, props.key, props.value);
            return;
        }

        Vue.set(state, 'passedProps', props);
    }
};

const actions = {
    triggerModalCallback(passedState, response) {
        state.callback(response);
    },
    triggerModalCallbackCancel(passedState, response) {
        if (state.callbackCancel) {
            state.callbackCancel(response);
        }
    },
}

const getters = {
    GET_ACTIVE_MODAL: (state) => state.activeModal,
    GET_ACTIVE_MODAL_PROPS: (state) => state.passedProps,
};

export default {
    state,
    mutations,
    getters,
    actions
}